import axiosInstance from 'core/network/axiosInstance'

export interface CatalogItemApiResponse {
  id: string
  name: string
  variant: string
  description?: string
  images?: string[]
  unit: string
  pack_weight_kg?: number
  moq: number
  mrp: number
  selling_price: number
  manufacturer_price?: number
  stock: number
  added_by: string
  is_deleted: boolean
  created_at: string
  updated_at: string
}

export interface CatalogListApiResponse {
  skip: number
  limit: number
  total: number
  data: CatalogItemApiResponse[]
}

export interface GetCatalogApiParams {
  skip: number
  limit: number
  search?: string
  status?: string
}

export interface CreateCatalogItemApiRequest {
  name: string
  variant: string
  description?: string
  images?: string[]
  unit?: string
  pack_weight_kg?: number
  moq: number
  mrp: number
  selling_price: number
  manufacturer_price?: number
  stock: number
}

// All fields optional — the backend only overwrites what's present in the body.
export interface UpdateCatalogItemApiRequest {
  name?: string
  variant?: string
  description?: string
  images?: string[]
  unit?: string
  pack_weight_kg?: number
  clear_pack_weight_kg?: boolean
  moq?: number
  mrp?: number
  selling_price?: number
  manufacturer_price?: number
  stock?: number
  is_deleted?: boolean
}

class CatalogueApiDatasource {
  async getCatalogItems(params: GetCatalogApiParams): Promise<CatalogListApiResponse> {
    const { data } = await axiosInstance.get<CatalogListApiResponse>('/api/v1/catalog', { params })
    return data
  }

  async getCatalogItemById(id: string): Promise<CatalogItemApiResponse> {
    const { data } = await axiosInstance.get<CatalogItemApiResponse>(`/api/v1/catalog/${id}`)
    return data
  }

  async createCatalogItem(payload: CreateCatalogItemApiRequest): Promise<CatalogItemApiResponse> {
    const { data } = await axiosInstance.post<CatalogItemApiResponse>('/api/v1/catalog', payload)
    return data
  }

  async updateCatalogItem(id: string, payload: UpdateCatalogItemApiRequest): Promise<CatalogItemApiResponse> {
    const { data } = await axiosInstance.put<CatalogItemApiResponse>(`/api/v1/catalog/${id}`, payload)
    return data
  }
}

export const catalogueApiDatasource = new CatalogueApiDatasource()
